import React from 'react';
import ActionButton from './ActionButton';

export default function ConfigButton(props) {
    const tooltip = 'This app does not need to be configured in this location.';

    return <ActionButton alias="settings" disabledTooltip={tooltip} {...props} />;
}
